import api from './api';

const authService = {
  // Send OTP
  sendOtp: async (data) => {
    const response = await api.post('/auth/send-otp', data);
    return response.data;
  },

  // Verify OTP
  verifyOtp: async (data) => {
    const response = await api.post('/auth/verify-otp', data);
    return response.data;
  },

  // Complete Registration
  register: async (data) => {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  // Login
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  // Create Admin
  createAdmin: async (data) => {
    const response = await api.post('/auth/create-admin', data);
    return response.data;
  },
};

export default authService;
